import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllDiarioObrasUseCase } from "../../../presentation/useCases/read/get_all_diario_obras_use_case";
import { DiarioObrasFilter } from "../../models/diario_obras_filter";
import { DiarioObrasLista } from "../../models/diario_obras_lista";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";


// GetAllDiarioObrasServicoUseCase


export class GetAllDiarioObrasServicoUseCase
  extends BasePaginatedUseCase<DiarioObrasLista>
  implements IGetAllDiarioObrasUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {
    super();
  }

  async getAllListagemDiariosObras(
    filter: DiarioObrasFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdDiarioObras === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository
      .getAllListagemDiariosObras(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
